<template>
  <div class="treeTableContainer">
    <div class="top">
      <span class="per">负责人列表：</span>
      <button class="primaryBtn" @click="searchAlco">搜索</button>
      <el-input class="ipt" placeholder="请输入昵称" v-model="searchText" style="width:200px;"></el-input>
    </div>
    <div class="treeTableTbody">
      <el-table class="borderTable"
        border ref="elderTable" 
        :data="modulesData" style="width:100%" v-loading="loading"
        @selection-change="selectionTableDtaChange" :row-key="getRowKeys">
        <el-table-column type="selection" align="center" width="50" :reserve-selection="true"></el-table-column>
        <el-table-column prop="nickName" label="昵称"></el-table-column>
        <el-table-column label="登录名">
          <template slot-scope="scope">{{ scope.row.loginName }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageWrap" v-if="pages.show && modulesData.length">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pages.currentPage" :page-sizes="pageSizes" :page-size="pages.pageSize"
        :pager-count="pagerCount" :layout="pageLayout" :total="pages.total"></el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["modulesData", "treeTableLabel", "isEdit", "sendTreeData", "pages", "pageSizes", "loading"],
    data() {
      return {
        pageLayout: 'total, sizes, prev, pager, next, jumper',
        pagerCount: 5,
        secltableData:[],//回显(所有选中状态)
        secltId: [], //所有选中id
        elderData: [],//表格数据
        checkData:[],
        searchText:''
      };
    },
    watch: {
      modulesData(newValue, oldValue) {
        console.log(newValue)
      },
      sendTreeData(newValue, oldValue) {
        this.$refs.elderTable.clearSelection()
        // console.log(newValue)
        this.checkData=newValue
        this.secltableData=this.checkData
        // this.secltId = []
        // for (let selectedItem of this.checkData) {
          // this.secltId.push(selectedItem.id)
          // this.$refs.elderTable.toggleRowSelection(selectedItem, true)
        // }
        // console.log(this.secltId);
        // this.$emit("sendCheckNode", this.secltId)

        // js 删除两个数组中id相同的对象
        let arr1 = this.modulesData
        let arr2 = this.secltableData
        //ES6的方法
        let add = arr2.filter(item => !arr1.some(ele=>ele.id===item.id));
        // console.log(add);

        this.elderData = this.modulesData
        this.$nextTick(() => {
          this.showSeclectRow()
        })
        add.forEach(items=>{
          this.$nextTick(() => {
            this.$refs.elderTable.toggleRowSelection(items, true)
          })
        })
      }
    },

    mounted() {},
    methods: {
      searchAlco(){
        this.$emit('nickName',this.searchText)
      },
      handleSizeChange(val) { //pageSize变化时函数
        this.$emit('sizeChange', val)
      },
      handleCurrentChange(val) { //当前页变化时函数
        this.$emit('currentChange', val)
      },
      //记录翻页选中
      getRowKeys(row) {
        return row.id
      },
      unique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
      },
      // 选择的表单（对选中数据处理，需要处理数据，用于传递给后台）
      selectionTableDtaChange (selection) {
        // console.log(selection);
        this.secltableData = selection
        // 去重获取被选中的id值存入到数组中
        this.secltId = []
        for (let selectedItem of selection) {
          this.secltId.push(selectedItem.id)
        }
        // console.log(this.secltId);
        this.$emit("sendCheckNode", this.secltId)
      },
      //回显
      showSeclectRow () {
        // console.log(this.secltableData);
        if (this.secltableData.length > 0) {
          this.secltableData.forEach(row => {
            this.elderData.forEach((item) => {
              if (row.id === item.id) {
                this.$refs.elderTable.toggleRowSelection(item, true)
              }
            })
          })
        }
      },
    },
  };
</script>

<style lang="scss">
  .treeTableContainer {
    .top {
      height: 36px;
      line-height: 36px;
      padding-bottom: 10px;
      overflow: hidden;
      .per{
        float: left;
      }
      .ipt{
        float: right;
      }
      .primaryBtn{
        margin-left: 20px;
        margin-right: 0;
        float: right;
      }
      .el-checkbox {
        line-height: 36px;
      }
      .el-input{
        .el-input__inner{
          height: 36px;
          line-height: 36px;
        }
      }
    }

    .treeTableTheader {
      ul {
        height: 36px;
        background: rgba(155, 187, 250, 0.3);
        border-bottom: 2px solid #2662DC;

        li {
          float: left;
          width: 150px;
          line-height: 36px;
          padding: 0 10px;

          &:first-child {
            width: 266px;
            padding-left: 20px;
            padding-right: 0;
          }

          &:nth-child(2) {
            width: 150px;
          }

          &:nth-child(3) {
            width: 350px;
          }

          // &:nth-child(4){
          //   width:350px;
          // }
        }
      }
    }

    .treeTableTbody {
      .borderTable {
        &::before {
          display: none;
        }
          th {
            background: #F2F2F2;
            font-weight: 500;
            font-size: 15px;

            &:nth-child(1) {
              .cell {
                padding-left: 14px;
              }
            }
          }
          td {
            border-bottom: 1px solid #E6E6E6;
            font-size: 14px;

            .cell {

              .el-button--small,
              .el-button--small.is-round {
                padding: 4px 6px;
              }
            }
          }
        .el-table__fixed-right::before {
          display: none;
        }

        .el-table-column--selection {
          border-right: 1px solid #E6E6E6;
          box-shadow: 2px 0 3px -1px #E6E6E6; //右边阴影
          z-index: 999;
        }
      }
    }

    .pageWrap {
      padding: 10px 0 10px;

      .el-select {
        .el-input {
          .el-select__caret {
            line-height: 28px !important;
          }
        }
      }
    }
  }
</style>